/**
 * row-status-chip.js
 */

import React from 'react';
import { Chip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Link } from 'react-router-dom';


const useStyles = makeStyles(theme => ({
  statusChip: {
    fontWeight: 500,
    cursor: 'pointer',
    '& .MuiChip-label': {
      display: 'flex',
      alignItems: 'center',
      lineHeight: '14px',
    },
    '& .MuiSvgIcon-root': {
      width: '14px',
      height: '14px',
      marginRight: theme.spacing(0.5),
    },
  },
}));


export default function RowStatusChip(props) {
  const {
    className,
    label,
    to,
    ...rest
  } = props;
  const classes = useStyles();

  const baseContent = (
    <Chip
      size='small'
      className={`${classes.statusChip} ${className}`}
      label={label}
      {...rest}
    />
  );

  const linkContent = to
    ? <Link to={to} style={{ textDecoration: 'none' }}>
      {baseContent}
    </Link>
    : baseContent;

  return linkContent;
}